var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"isLoading":_vm.caseLoading}},[_c('v-layout',{staticClass:"homepage-card-container metric-panel",attrs:{"row":"","wrap":"","fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }